import { ImSpinner8 } from 'react-icons/im';

interface ImportProgressBarProps {
  progress: number; // 0-100
}

/**
 * データ取り込み中のプログレスバー
 */
export function ImportProgressBar({ progress }: ImportProgressBarProps) {
  return (
    <div className="flex w-[610px] flex-col justify-center gap-xs">
      {/* ヘッダー部分 */}
      <div className="flex items-end justify-between gap-sm">
        <h3 className="text-heading-xxs">データ取り込み中</h3>
        <div className="flex items-center gap-xxs">
          <p className="text-body-sm">{progress}%</p>
          <div className="inline-block animate-spin">
            <ImSpinner8 className="size-icon-xs text-primary" />
          </div>
        </div>
      </div>

      {/* プログレスバー */}
      <div className="h-2 w-full overflow-hidden rounded-full border border-border bg-white">
        <div
          className="h-full rounded-full bg-primary transition-all duration-300"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}
